<template>
  <b-navbar toggleable="lg" :variant="getLayoutNavbarBg()" class="layout-navbar align-items-lg-center container-p-x">

    <!-- Brand demo (see demo.css) -->
    <b-navbar-brand to="/" class="app-brand demo d-lg-none py-2 mr-4">
      <span class="app-brand-logo demo">
        <img :src="`${publicUrl}img/logos/logo.png`" width="50" alt="">
      </span>
      <span class="app-brand-text demo font-weight-normal ml-2">مستشفى الطارق</span>
    </b-navbar-brand>

    <!-- Sidenav toggle (see demo.css) -->
    <b-navbar-nav class="layout-sidenav-toggle d-lg-none align-items-lg-center mr-auto" v-if="sidenavToggle">
      <a class="nav-item nav-link px-0 mr-lg-4" href="javascript:void(0)" @click="toggleSidenav">
        <i class="ion ion-md-menu text-large align-middle" />
      </a>
    </b-navbar-nav>

    <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>

    <b-collapse is-nav id="app-layout-navbar">
      <!-- Divider -->
      <hr class="d-lg-none w-100 my-2">

      <b-navbar-nav class="align-items-lg-center">
        <!-- Search -->
        <!-- <label class="nav-item navbar-text navbar-search-box p-0 active">
          <i class="ion ion-ios-search navbar-icon align-middle"></i>
          <span class="navbar-search-input pl-2">
            <input id="search-bar" type="text" class="form-control navbar-text mx-2" placeholder="Search..."
             style="width:200px;" v-model="keywords" @keyup.enter="generalSearch">
          </span>
        </label> -->
      </b-navbar-nav>

      <b-navbar-nav class="align-items-lg-center ml-auto">
        <!-- Message Section -->

        <!-- Divider -->
        <!-- <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1">|</div> -->
        <b-nav-item-dropdown :right="!isRTL" class="demo-navbar-user">
          <template slot="button-content">
            <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
              <img v-if="this.$store.state.user.avatar === null || this.$store.state.user.avatar === ''"
              :src="`${publicUrl}img/avatars/1.png`" alt class="d-block ui-w-30 rounded-circle" width="30" height="30">

              <img v-else :src="this.$store.state.user.avatar" alt class="d-block ui-w-30 rounded-circle">

              <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{ profile.first_name + ' ' + profile.last_name }}</span>
            </span>
          </template>

          <!-- <b-dd-item><i class="ion ion-ios-person text-lightest"></i> &nbsp; My profile</b-dd-item> -->
          <!-- <b-dd-item><i class="ion ion-ios-mail text-lightest"></i> &nbsp; Messages</b-dd-item> -->
          <b-dd-item to="/account-settings" ><i class="ion ion-md-settings text-lightest"></i> &nbsp; إعدادات الحساب</b-dd-item>
          <b-dd-item to="/account-settings/password" ><i class="ion ion-md-lock text-lightest"></i> &nbsp; تغيير كلمة المرور</b-dd-item>
          <b-dd-divider />
          <b-dd-item @click.stop="logout()"><i class="ion ion-ios-log-out text-danger"></i> &nbsp; خروج</b-dd-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>

    <!-- CuiVueBlockui -->
    <BlockUI :html="html" v-if="isBusy"/>
    <!-- CuiVueBlockui -->

  </b-navbar>

</template>

<style>

.loading-container .loading-backdrop {
  background: #fff !important;
  opacity: .7 !important;
}
.loading-container .loading {
  background: none !important;
  box-shadow: none !important;
}

#search-bar::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: #fff !important;
}
#search-bar::-moz-placeholder { /* Firefox 19+ */
  color: #fff !important;
}
#search-bar:-ms-input-placeholder { /* IE 10+ */
  color: #fff !important;
}
#search-bar:-moz-placeholder { /* Firefox 18- */
  color: #fff !important;
}

.ui-w-40 {
    width: 40px !important;
    height: 40px;
}

</style>

<style src="@/vendor/libs/spinkit/spinkit.scss" lang="scss"></style>

<script>
import Vue from 'vue'
import BlockUI from 'vue-blockui'
import axios from 'axios'
import ToastPlugin from 'bootstrap-vue'
Vue.use(BlockUI)
Vue.use(ToastPlugin)

export default {
  name: 'app-layout-navbar',

  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      profile: {
        first_name: '',
        last_name: ''
      },
      bs4Toasts: {
        variant: null,
        avatar: 'img/avatars/1.png',
        title: 'Default',
        time: '11 mins ago',
        message: 'Hello, world! This is a toast message.'
      },

      isBusy: false,
      // html:null,
      html: `
      <div class="sk-wave sk-primary">
        <div class="sk-rect sk-rect1"></div>
              <div class="sk-rect sk-rect2"></div>
              <div class="sk-rect sk-rect3"></div>
              <div class="sk-rect sk-rect4"></div>
              <div class="sk-rect sk-rect5"></div>    
        </div>
      <h5 class="text-center mb-0">Searching...</h5>`,
      keywords: ''
    }
  },

  computed: {
    user () {
      return this.$store.state.user.data
    }
  },
  created () {

  },

  mounted () {
    this.getProfile()
  },

  watch: {

  },

  methods: {
    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },

    getLayoutNavbarBg () {
      return this.layoutNavbarBg
    },

    getProfile () {
      axios.get('/api/user').then(res => {
        const user = res.data.data
        this.profile = user
        this.$store.state.user = user
      })
    },

    showToastMessage (variant = null) {
      // ToastPlugin.toast
      this.$bvToast.toast('Toast body content', {
        title: `Variant ${variant || 'default'}`,
        variant: variant,
        solid: true
      })
    },

    // async logout () {
    //   await axios.get('/sanctum/csrf-cookie').then(res => {
    //     axios.post('/logout')
    //     // console.log('Saad')
    //     // localStorage.removeItem('userToken')
    //     // location.reload()
    //     this.$store.dispatch('profile')
    //     location.reload()
    //     this.$router.push({ path: '/' })
    //   })
    // }
    async logout () {
      await this.$store.dispatch('logout').then(() => {
        this.$router.push({ path: '/' })
      })
    }
  }
}
</script>
